import { render } from "./Footer24hTelevie.vue?vue&type=template&id=6bcbd732&scoped=true"
import script from "./Footer24hTelevie.vue?vue&type=script&lang=js"
export * from "./Footer24hTelevie.vue?vue&type=script&lang=js"

import "./Footer24hTelevie.vue?vue&type=style&index=0&id=6bcbd732&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcbd732"]])

export default __exports__